import { QuoteFormRequestParams } from '@lio/api-types';
import { formVersionQueryKeys } from '@services/formVersion/keys';
import { quoteFormQueryKeys } from '@services/quoteForm/keys';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const usePostAutomaticFormUpdates = () => {
  const client = useClient();
  const queryClient = useQueryClient();

  const result = useMutation({
    mutationFn: async ({ quoteId }: QuoteFormRequestParams) => {
      return client.post(`quote/${quoteId}/quote-form/automatic-update`).json();
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: quoteFormQueryKeys.searchWithParams({ quoteId: variables.quoteId }),
      });
      queryClient.invalidateQueries({
        queryKey: formVersionQueryKeys.get(variables.quoteId),
      });
    },
  });

  return {
    ...result,
    postAutomaticFormUpdates: result.mutate,
    postAutomaticFormUpdatesAsync: result.mutateAsync,
  };
};
